module.exports = __webpack_public_path__ + "img/404.61221805.gif";